/* Astrak global swipe support for .axt and .axg carousels */
(function(){
  function addSwipe(el, onL, onR){
    var sx=0, sy=0;
    el.addEventListener('touchstart', function(e){ sx=e.touches[0].clientX; sy=e.touches[0].clientY; }, {passive:true});
    el.addEventListener('touchend', function(e){
      var dx=e.changedTouches[0].clientX-sx;
      var dy=e.changedTouches[0].clientY-sy;
      if(Math.abs(dx)<40||Math.abs(dx)<Math.abs(dy)) return;
      if(dx<0) onL(); else onR();
    }, {passive:true});
  }

  function initSwipe(){
    /* Testimonial carousels (.axt) */
    document.querySelectorAll('[data-axt]').forEach(function(root){
      if(root.dataset.swipeInit) return;
      root.dataset.swipeInit = '1';
      var prev = document.querySelector('[data-axt-prev]');
      var next = document.querySelector('[data-axt-next]');
      if(!prev || !next) return;
      addSwipe(root,
        function(){ next.click(); },
        function(){ prev.click(); }
      );
    });

    /* Image gallery (.axg) */
    document.querySelectorAll('[data-axg]').forEach(function(root){
      if(root.dataset.swipeInit) return;
      root.dataset.swipeInit = '1';
      var stage = root.querySelector('.axg-stage') || root;
      var prev = root.querySelector('[data-axg-prev]');
      var next = root.querySelector('[data-axg-next]');
      if(!prev || !next) return;
      addSwipe(stage,
        function(){ next.click(); },
        function(){ prev.click(); }
      );
    });

    /* GeoXD bucket image carousel (.axc) */
    document.querySelectorAll('[data-axc]').forEach(function(root){
      if(root.dataset.swipeInit) return;
      root.dataset.swipeInit = '1';
      var prev = document.querySelector('[data-axc-prev]');
      var next = document.querySelector('[data-axc-next]');
      if(!prev || !next) return;
      addSwipe(root,
        function(){ next.click(); },
        function(){ prev.click(); }
      );
    });

    /* Pad carousels (.pc) */
    document.querySelectorAll('[data-pc]').forEach(function(root){
      if(root.dataset.swipeInit) return;
      root.dataset.swipeInit = '1';
      var prev = root.querySelector('[data-pc-prev]');
      var next = root.querySelector('[data-pc-next]');
      if(!prev || !next) return;
      addSwipe(root,
        function(){ next.click(); },
        function(){ prev.click(); }
      );
    });
  }

  if(document.readyState !== 'loading'){
    initSwipe();
  } else {
    document.addEventListener('DOMContentLoaded', initSwipe);
  }
})();

/* Market link localisation: rewrites internal links (href="/...") to include
   the active market subfolder (e.g. /en-fr) so visitors stay inside their
   market when navigating. On the primary market (root "/") it is a no-op.
   The country selector (#countrySel) is skipped on purpose, since those
   links are meant to switch markets. */
(function(){
  function astrakLocalizeLinks(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if(!root || root === '/') return;
    var prefix = root.replace(/\/+$/, '');
    if(!prefix) return;
    var links = document.querySelectorAll('a[href^="/"]');
    for(var i=0; i<links.length; i++){
      var a = links[i];
      if(a.closest && a.closest('#countrySel')) continue;
      var href = a.getAttribute('href');
      if(!href || href.charAt(0) !== '/' || href.charAt(1) === '/') continue;
      if(href === prefix || href.indexOf(prefix + '/') === 0) continue;
      a.setAttribute('href', prefix + href);
    }
  }
  if(document.readyState !== 'loading'){
    astrakLocalizeLinks();
  } else {
    document.addEventListener('DOMContentLoaded', astrakLocalizeLinks);
  }
})();
